<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary card-header-icon">
            <div class="card-icon">
              <i class="material-icons">chrome_reader_mode</i>
            </div>
            <h4 class="card-title">Invoices</h4>
          </div>

          <div class="card-body">
            <div class="toolbar">
              <!--        Here you can write extra buttons/actions for the toolbar              -->
            </div>


            <loading *ngIf="loading"></loading>

            <div *ngIf="!loading">
              <!-- <div class="row" style="margin-bottom: 20px">
                <div class="col-12" style="text-align: right">

                  <button class="btn btn-outline-primary btn-md" (click)="printBulk()" [disabled]="bulk.length === 0">
                    <i class="fa fa-print" aria-hidden="true"></i> &nbsp; Print
                  </button> &nbsp;

                  <button
                    class="btn btn-success btn-md"
                    routerLink="/sales-orders/new"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; New
                    Sale Order
                  </button>

                </div>
              </div>
              <br /> -->

              <dinamic-table
                *ngIf="!loading"
                [id]="'saleordersTable'"
                [data]="invoices"
                [campoBusqueda]="campoBusqueda"
                [perPage]="itemsPorPagina"
                [page]="paginaActual"
                [total_items_count]="totalItems"
                [total_pages]="totalPaginas"
                [bulk]="bulk"
                [cleanbulk]="true"
                (buscar)="getInvoices($event)"
                (action_button)="action($event)"
                ></dinamic-table>
                <!-- [config]="options" -->
                <!-- (newConfig)="updateConfig($event)" -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
